import * as React from "react";
import Proptypes from "prop-types";
//MUI Components
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
//CSS
import "./assests/css/styles.css";
function SelectInput(props) {
  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth error={props.error}>
        <InputLabel id="demo-simple-select-label">{props.label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          fullWidth={props.fullWidth}
          id="demo-simple-select"
          label={props.label}
          variant="standard"
          name={props.name}
          placeholder={props.placeholder}
          value={props.value}
          onChange={(event) => props.handleChange(event, props.name)}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 200, // Restrict dropdown height
                overflowY: "auto", // Enable scrolling
                marginTop: 8, // Add padding on top
              },
            },
            disablePortal: true, // Prevent it from going out of viewport
          }}
        >
          {props.options.map((option) => (
            <MenuItem key={option.value} value={option.value} sx={{ padding: "10px 16px" }}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {props.error && <FormHelperText>{props.helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
}

SelectInput.propTypes = {
  label: Proptypes.string.isRequired, // label for the select input
  options: Proptypes.array.isRequired, // array of objects with value and label properties
  value: Proptypes.string.isRequired, // value of the select input
};

export default SelectInput;
